module.exports = __webpack_public_path__ + "static/media/Screenshot_4.3085e247.png";